import { render, staticRenderFns } from "./newAssetsInfo30.vue?vue&type=template&id=38db8188&scoped=true&"
import script from "./newAssetsInfo30.vue?vue&type=script&lang=js&"
export * from "./newAssetsInfo30.vue?vue&type=script&lang=js&"
import style0 from "./newAssetsInfo30.vue?vue&type=style&index=0&id=38db8188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db8188",
  null
  
)

export default component.exports